export default function ProductSliderSkeleton() {
  return (
    <section className="storefront-section-spacing">
      <div className="storefront-container">
        {/* Header Skeleton */}
        <div className="flex items-center justify-between mb-6">
          <div className="h-8 w-48 bg-neutral-200 rounded animate-pulse"></div>
          <div className="h-5 w-20 bg-neutral-200 rounded animate-pulse"></div>
        </div>

        {/* Products Skeleton */}
        <div className="flex gap-4 overflow-hidden">
          {[1, 2, 3, 4, 5].map((i) => (
            <div
              key={i}
              className="flex-none w-[calc(50%-0.5rem)] sm:w-[calc(33.333%-0.667rem)] lg:w-[calc(25%-0.75rem)] xl:w-[calc(20%-0.8rem)]"
            >
              <div className="storefront-card overflow-hidden">
                {/* Image Skeleton */}
                <div className="aspect-square bg-neutral-200 animate-pulse"></div>

                {/* Content Skeleton */}
                <div className="p-4">
                  {/* Title Skeleton */}
                  <div className="space-y-2 mb-3">
                    <div className="h-4 bg-neutral-200 rounded animate-pulse"></div>
                    <div className="h-4 bg-neutral-200 rounded w-3/4 animate-pulse"></div>
                  </div>

                  {/* Price Skeleton */}
                  <div className="h-6 w-20 bg-neutral-200 rounded animate-pulse"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
